import { NativeModules } from 'react-native';
import { getSearchParams, getSectorInformation } from './searchConnectorUtil';

// add object type when search is refactored in ts
export const SearchConnector = (data, pageName) => {
  const { UserSessionModule } = NativeModules;
  if (!UserSessionModule || !UserSessionModule.updateRecentSearch) {
    return;
  }

  UserSessionModule.updateRecentSearch('train', getSearchParams(data, pageName));
};

export const SectorConnector = (data, pageName) => {
  const { UserSessionModule } = NativeModules;
  if (!UserSessionModule || !UserSessionModule.updateRecentSearch) {
    return;
  }

  UserSessionModule.updateRecentSearch('train', getSectorInformation(data, pageName));
};
